import React from 'react';

const Columns = () => (
  <svg width="24" height="24" className="rect" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="6" width="2" height="12" rx="1" fill="#787F88" />
    <rect x="11" y="6" width="2" height="12" rx="1" fill="#787F88" />
    <rect x="16" y="6" width="2" height="12" rx="1" fill="#787F88" />
  </svg>
);

export default Columns;
